<template>
  <div class="mastercard-login-logo">
    <img src="@/assets/img/mc-color-logo.svg" />
  </div>
</template>

<script setup lang="ts">
</script>

<style></style>
